import React from "react";

export default function Partners() {
  return (
    <>
      <style>{`
        .partners-section {
          padding: 70px 0;
          background: #ffffff;
          overflow: hidden;
        }

        .partners-title {
          text-align: center;
          font-size: 30px;
          font-weight: 900;
          margin-bottom: 40px;
        }

        /* SLIDER WRAPPER */
        .logo-slider {
          width: 100%;
          display: flex;
          overflow: hidden;
          position: relative;
        }

        .logo-track {
          display: flex;
          gap: 60px;
          animation: scrollLeft 28s linear infinite;
        }

        .partner-logo {
          height: 55px;
          filter: grayscale(100%);
          opacity: 0.75;
          transition: 0.3s ease;
        }

        .partner-logo:hover {
          filter: grayscale(0%);
          opacity: 1;
          transform: translateY(-3px);
        }

        @keyframes scrollLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        @media(max-width: 768px) {
          .partner-logo {
            height: 38px;
          }
        }
      `}</style>

      <section className="partners-section">
        <h2 className="partners-title">Compatible With Leading Carriers & Platforms</h2>

        <div className="logo-slider">
          <div className="logo-track">

            {/* FIRST LOOP */}
            <img src="/partner/usps.svg" className="partner-logo" alt="USPS" />
            <img src="/partner/ups.svg" className="partner-logo" alt="UPS" />
            <img src="/partner/fedex.svg" className="partner-logo" alt="FedEx" />
            <img src="/partner/dhl.svg" className="partner-logo" alt="DHL" />
            <img src="/partner/amazon.svg" className="partner-logo" alt="Amazon" />
            <img src="/partner/shopify.svg" className="partner-logo" alt="Shopify" />
            <img src="/partner/woocommerce.svg" className="partner-logo" alt="WooCommerce" />
            <img src="/partner/square.svg" className="partner-logo" alt="Square" />
            <img src="/partner/walmart.svg" className="partner-logo" alt="Walmart" />
            <img src="/partner/ebay.svg" className="partner-logo" alt="eBay" />

            {/* DUPLICATE LOOP FOR INFINITE SLIDE */}
            <img src="/partner/usps.svg" className="partner-logo" alt="USPS" />
            <img src="/partner/ups.svg" className="partner-logo" alt="UPS" />
            <img src="/partner/fedex.svg" className="partner-logo" alt="FedEx" />
            <img src="/partner/dhl.svg" className="partner-logo" alt="DHL" />
            <img src="/partner/amazon.svg" className="partner-logo" alt="Amazon" />
            <img src="/partner/shopify.svg" className="partner-logo" alt="Shopify" />
            <img src="/partner/woocommerce.svg" className="partner-logo" alt="WooCommerce" />
            <img src="/partner/square.svg" className="partner-logo" alt="Square" />
            <img src="/partner/walmart.svg" className="partner-logo" alt="Walmart" />
            <img src="/partner/ebay.svg" className="partner-logo" alt="eBay" />

          </div>
        </div>
      </section>
    </>
  );
}
